<div class="admin-layout">
  <div class="admin-stats-section">
    <h3 class="section-title">Statistics</h3>
    @if (loading) {
      <div class="admin-loading">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        Loading…
      </div>
    } @else if (stats) {
      <div class="stats-row">
        <div class="panel stat-card">
          <div class="stat-card-content">
            <span class="stat-label">Total users</span>
            <span class="stat-value">{{ stats.totalUsers }}</span>
          </div>
          <div class="stat-card-icon stat-icon-chart">
            <i class="bi bi-people"></i>
          </div>
        </div>
        <div class="panel stat-card">
          <div class="stat-card-content">
            <span class="stat-label">Active sessions</span>
            <span class="stat-value">{{ stats.activeSessions }}</span>
          </div>
          <div class="stat-card-icon stat-icon-target">
            <i class="bi bi-box-arrow-in-right"></i>
          </div>
        </div>
        <div class="panel stat-card">
          <div class="stat-card-content">
            <span class="stat-label">Messages (unread)</span>
            <span class="stat-value">{{ stats.contactMessagesUnread }}</span>
          </div>
          <div class="stat-card-icon stat-icon-chart">
            <i class="bi bi-envelope"></i>
          </div>
        </div>
        <div class="panel stat-card">
          <div class="stat-card-content">
            <span class="stat-label">Tests (last 30 days)</span>
            <span class="stat-value">{{ stats.testsLast30Days }}</span>
          </div>
          <div class="stat-card-icon stat-icon-target">
            <i class="bi bi-clipboard-check"></i>
          </div>
        </div>
        <a routerLink="/admin/fraud" class="panel stat-card stat-card-link">
          <div class="stat-card-content">
            <span class="stat-label">Open fraud signals</span>
            <span class="stat-value">{{ stats.openFraudEvents ?? 0 }}</span>
          </div>
          <div class="stat-card-icon stat-icon-chart">
            <i class="bi bi-shield-exclamation"></i>
          </div>
        </a>
      </div>
    } @else {
      <p class="text-muted mb-0">Could not load stats.</p>
    }
  </div>

  <div class="panel chart-card">
    <h3 class="section-title">User Activity (last 30 days)</h3>
    @if (loading) {
      <div class="admin-loading">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        Loading…
      </div>
    } @else if (activityTimeSeries.length > 0) {
      <div id="adminActivityChart">
        <apx-chart
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [dataLabels]="chartOptions.dataLabels!"
          [stroke]="chartOptions.stroke!"
          [xaxis]="chartOptions.xaxis!"
          [yaxis]="chartOptions.yaxis!"
          [legend]="chartOptions.legend!"
          [grid]="chartOptions.grid!"
          [markers]="chartOptions.markers!"
        ></apx-chart>
      </div>
    } @else {
      <p class="text-muted mb-0">No activity data available.</p>
    }
  </div>
</div>
